Game.Prefabs.Effect = function( game, x, y, type, group ) {

	// Setup Effect.
	Phaser.Sprite.call( this, game, x, y, type );

	// Add to the display group.
	group.add( this );

	this.bringToTop();

};


Game.Prefabs.Effect.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Effect.constructor = Game.Prefabs.Effect;


Game.Prefabs.Effect.prototype.explode = function() {

	var animation = this.animations.play( 'explode' );

	animation.onComplete.add(
		this.kill,
		this
	);

};